// extracted by mini-css-extract-plugin
export default {"root":"Card_root__UAmJF","header":"Card_header__LgAhk","title":"Card_title__fjt9r","subTitle":"Card_subTitle__3KCDY","body":"Card_body__RHED-"};